import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("p", null, "Online können wir Ihnen kein Angebot erstellen.", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, " Bitte rufen Sie im Maklervertriebscenter unter der Telefonnummer 040 3766 3222 an. Sie erreichen uns von Montag bis Freitag von 8:00 bis 18:00 Uhr. ", -1))
  ], 64))
}